import type { StyleProps } from "@chakra-ui/react";
import { Divider as ChakraDivider } from "@chakra-ui/react";
import type { ThemeColors } from "theme/tokens/colors";

export const DIVIDER_ORIENTATION = ["horizontal", "vertical"] as const;

export interface DividerProps extends StyleProps {
  orientation?: (typeof DIVIDER_ORIENTATION)[number];
  color?: ThemeColors;
}

/**
 * Visually separate related groups, sections, or adjacent items when spacing
 * alone is not sufficient to communicate structure.
 */
export const Divider = ({
  orientation,
  color = "border.divider",
  ...customStyles
}: DividerProps) => (
  <ChakraDivider
    orientation={orientation}
    borderColor={color}
    opacity="1"
    height={orientation === "vertical" ? "100%" : "initial"}
    width={orientation === "vertical" ? "0" : "unset"}
    {...customStyles}
  />
);
